module.exports = __webpack_public_path__ + "static/media/POWER RANGERS 3.a6b89a5d.jpg";